"use client";
import { Auction, AuctionSettings, Lot } from "@prisma/client";
import { Flex, Text } from "@radix-ui/themes";
import { Button } from "../components/ui/button";
import BuyerHomeAuctionDetails from "./BuyerHomeAuctionDetails";
import BuyerHomeHeader from "./BuyerHomeHeader";
import Container from "../components/Container";
import Link from "next/link";

export interface LotWithImage extends Lot {
  imageKey: string | null;
}

export interface AuctionWithImage extends Auction {
  imageKey: string | null;
}

interface Props {
  featuredAuctions: (Auction & { settings: AuctionSettings })[];
}

const BuyerHome = ({
  featuredAuctions,
}: Props) => {

  return (
    <Container direction="column">
      <div className="grid grid-cols-1 gap-12 mt-4 px-4 py-8">
        {featuredAuctions.map((auction, index) => (
          <Flex
            key={auction.id}
            direction="column"
            justify="center"
            align="center"
            className="gap-6 p-4"
          >
            <Flex
              direction="column"
              align="center"
              className="gap-4 w-full"
            >
              <BuyerHomeHeader title={auction.title} header={index === 0} />
              <Text className="max-w-[80%] text-center">
                {auction.settings.description}
              </Text>
            </Flex>
            <BuyerHomeAuctionDetails
              startDate={auction.startDate}
              endDate={auction.endDate}
            />
            <Link href={`/auctions/${auction.id}`} prefetch={false} className="mx-auto">
              <Button
                className="color-inverting-button-base hover:bg-white"
              >
                View catalogue
              </Button>
            </Link>
          </Flex>
        ))}
      </div>
    </Container>
  );
};

export default BuyerHome;
